import { render, staticRenderFns } from "./MensajeDibujante.vue?vue&type=template&id=a362359c&scoped=true&"
import script from "./MensajeDibujante.vue?vue&type=script&lang=js&"
export * from "./MensajeDibujante.vue?vue&type=script&lang=js&"
import style0 from "./MensajeDibujante.vue?vue&type=style&index=0&id=a362359c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a362359c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
